import { Input, Paper, TextField, Typography } from '@mui/material';
import React, { useRef } from 'react';
import {
  LanguageModel,
  TranslationModel,
} from '../../../../config/types/models';
import { TranslationInput } from '../../../../config/types/custom/TranslationInput';
import { useTranslate } from 'react-admin';
import CustomInput from '../../../../components/customInput/CustomInput';

type IProps = {
  name: string;
  translations: TranslationInput[];
  setName: (a: string) => void;
  setTranslations: (a: TranslationInput[]) => void;
  languages: LanguageModel[];
  slug: string;
  setSlug: (a: string) => void;
};

function ProductNames({
  name,
  translations,
  setName,
  setTranslations,
  languages,
  slug,
  setSlug,
}: IProps) {
  const t = useTranslate();
  const onChangeTranslation = (lang: LanguageModel, val: string) => {
    const newTranslations = [
      ...translations.filter(
        (c) => !(c.languageId === lang.id && c.key === 'name')
      ),
      {
        languageId: lang.id,
        key: 'name',
        value: val,
      },
    ];
    setTranslations(newTranslations);
  };
  return (
    <>
      <Typography variant='subtitle1'>{t('productName')}</Typography>
      <CustomInput
        name='slug'
        defaultValue={slug}
        label={t('slug')}
        placeholder={'Slug'}
        onBlur={(e) => setSlug(e.target.value)}
        style={{
          width: '100%',
        }}
      />

      <CustomInput
        name='name'
        defaultValue={name}
        label={languages?.find((c) => c.isDefault === true)?.name || null}
        placeholder={languages?.find((c) => c.isDefault === true)?.name}
        style={{
          width: '100%',
        }}
        onBlur={(e) => setName(e.target.value)}
      />
      {languages
        ?.filter((c) => c.isDefault === false)
        .map((lang) => (
          <CustomInput
            label={lang.name}
            style={{
              width: '100%',
            }}
            value={
              translations?.find(
                (c) => c.languageId === lang.id && c.key === 'name'
              )?.value || ''
            }
            onChange={(e) => onChangeTranslation(lang, e.target.value)}
          />
        ))}
    </>
  );
}

export default ProductNames;
